"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = __importDefault(require("axios"));
var AxiosBackedAuthenticatableSource_1 = require("../abstracts/AxiosBackedAuthenticatableSource");
var ganttlab_entities_1 = require("ganttlab-entities");
var GitHubRepository_1 = require("./types/GitHubRepository");
var GitHubGateway = /** @class */ (function (_super) {
    __extends(GitHubGateway, _super);
    function GitHubGateway() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.slug = 'github';
        _this.name = 'GitHub';
        return _this;
    }
    GitHubGateway.prototype.setCredentials = function (credentials) {
        this.credentials = { token: credentials.token };
        this.setAxiosInstance(axios_1.default.create({
            baseURL: 'https://api.github.com/',
            headers: {
                common: {
                    Authorization: "token " + this.credentials.token,
                },
            },
        }));
    };
    GitHubGateway.prototype.getUrl = function () {
        return 'https://github.com';
    };
    GitHubGateway.prototype.getLoggedInUser = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.safeAxiosRequest({
                            method: 'GET',
                            url: '/user',
                        })];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, new ganttlab_entities_1.User(data.email, data.login, data.html_url, data.avatar_url)];
                }
            });
        });
    };
    GitHubGateway.prototype.searchRepositories = function (search) {
        return __awaiter(this, void 0, void 0, function () {
            var data, projectsList, _i, _a, repo;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.safeAxiosRequest({
                            method: 'GET',
                            url: '/search/repositories',
                            params: {
                                // eslint-disable-next-line @typescript-eslint/camelcase
                                per_page: 10,
                                q: search,
                            },
                        })];
                    case 1:
                        data = (_b.sent()).data;
                        projectsList = [];
                        for (_i = 0, _a = data.items; _i < _a.length; _i++) {
                            repo = _a[_i];
                            projectsList.push(new GitHubRepository_1.GitHubRepository(repo.name, repo.full_name, repo.html_url, repo.description, 
                            // eslint-disable-next-line @typescript-eslint/camelcase
                            { avatar_url: repo.owner.avatar_url }));
                        }
                        return [2 /*return*/, projectsList];
                }
            });
        });
    };
    return GitHubGateway;
}(AxiosBackedAuthenticatableSource_1.AxiosBackedAuthenticatableSource));
exports.GitHubGateway = GitHubGateway;
//# sourceMappingURL=GitHubGateway.js.map